import { z } from "zod";

export default () => z.object({
    currentPassword: z.string().min(1),
    newPassword: z.string().min(1),
});